import { IconTextCell } from "./InterviewCells";

/**
 * s237 (chapter three PR 2; rule 159 — one job, one piece): THE "Other — type it" BOX, lifted out of chapter two's engine
 * (`ch2/Ch2Engine.tsx`, s235 PR C) so chapter two and the shared tile-to-row engine draw the same piece.
 *
 * Rule 41: a picker answered "Other — type it" opens its box UNDER ITS OWN COLUMN; the words are the field's Other-specify
 * detail (OTHER-SPECIFY-1), saved through the screen's own write. Once words are typed, the picker shows them in place of
 * "Other — type it" (D-235.87) — `withTypedOther`.
 */

/** The board's Other choice, word for word (every board writes it this way). */
export const OTHER_WORD = "Other — type it";
/** s235 (findings item 13(7)): a box with no words of its own reads the board's — never the column's header. */
export const OTHER_BOX_LABEL = "Type it";
export const OTHER_BOX_PLACEHOLDER = "Type the exact name";

/** The picker's options with the Other line showing the typed words (D-235.87). `isOther` tells which stored value is
 *  the Other choice. Pure. */
export function withTypedOther<O extends { value: string; label: string }>(options: readonly O[], isOther: (value: string) => boolean, typed: string): O[] {
  const t = typed.trim();
  return t ? options.map((o) => (isOther(o.value) ? { ...o, label: t } : o)) : [...options];
}

export function OtherBox({ label, placeholder, value, onCommit, testId }: {
  /** The board's `otherLabel` ("What kind", "Why"), else "Type it". */
  label?: string;
  placeholder?: string;
  value: string;
  onCommit: (text: string) => void;
  testId: string;
}) {
  const words = label ?? OTHER_BOX_LABEL;
  return (
    <div className="flex max-w-[320px] flex-col gap-1.5" data-testid={testId}>
      <span className="text-[14px] text-warm-charcoal">{words}</span>
      <IconTextCell value={value} placeholder={placeholder ?? OTHER_BOX_PLACEHOLDER} ariaLabel={words} onCommit={onCommit} testId={`${testId}-input`} />
    </div>
  );
}
